// REVISIONS
export const REVISIONS_URL = 'rota-revisions'
export const REVISIONS_PUBLISH_URL = 'rota-revisions/publish'
export const REVISIONS_PUBLISH_QUERY_KEY = 'rota-revisions/publish'
export const REVISIONS_UPDATE_COUNTS_URL = 'rota-revisions/update-counts'
export const REVISIONS_QUERY_KEY = 'revisions'

// REVISION
export const REVISION_URL = 'rota-revisions/revision'
export const REVISION_QUERY_KEY = 'revision'
export const REVISION_CANCEL_URL = 'rota-revisions/cancel-event'
export const REVISION_CANCEL_QUERY_KEY = 'cancel-revision'
export const REVISION_PUBLISH_QUERY_KEY = 'publish-revision'
export const REVISION_REOPEN_URL = 'rota-revisions/reopen-event'
export const REVISION_REOPEN_QUERY_KEY = `reopen-revision`
export const REVISION_ROLLBACK_URL = 'rota-revisions/rollback'
export const REVISION_ROLLBACK_QUERY_KEY = 'rollback-revision'
export const REVISION_UPDATE_URL = 'rota-revisions/update-details'
export const REVISION_UPDATE_QUERY_KEY = 'update-revision'

// INSTANCES
export const INSTANCES_URL = 'rota-instances'
export const INSTANCES_QUERY_KEY = 'instances'
export const INSTANCE_QUERY_KEY = 'instance'
export const INSTANCES_CREATE_URL = 'rota-instances/create-events'
export const INSTANCES_CREATE_QUERY_KEY = 'create-events'
export const INSTANCES_DELETE_URL = 'rota-instances/delete-events'
export const INSTANCES_DELETE_QUERY_KEY = 'delete-events'
export const INSTANCES_UPDATE_URL = 'rota-instances/update-events'
export const INSTANCES_UPDATE_QUERY_KEY = 'update-events'
export const EDIT_TRAVEL_INFO_URL = 'rota-instances/travel-info'
export const EDIT_TRAVEL_INFO_QUERY_KEY = 'create-events'

// ALLOCATION
export const ALLOCATION_LIST_URL = 'rota-revisions/allocation-list'
export const ALLOCATION_LIST_QUERY_KEY = 'allocation-list'
export const ALLOCATE_CARER_URL = 'rota-revisions/allocate-carer'
export const ALLOCATE_CARER_QUERY_KEY = 'allocate-carer'
export const ALLOCATION_DOUBLE_BOOKINGS_URL = 'rota-revisions/double-bookings'
export const ALLOCATION_DOUBLE_BOOKINGS_QUERY_KEY = 'double-bookings'

// CLOCK IN / OUT
export const CLOCK_IN_URL = 'rota-instances/clock-in'
export const CLOCK_IN_QUERY_KEY = 'clock-in'
export const CLOCK_OUT_URL = 'rota-instances/clock-out'
export const CLOCK_OUT_QUERY_KEY = 'clock-out'
export const CARERS_CLOCKED_IN_URL = 'rota-instances/carers-clocked-in'
export const CARERS_CLOCKED_IN_QUERY_KEY = 'carers-clocked-in'

// WARNINGS TOLERANCE SETTINGS
export const WARNINGS_TOLERANCE_QUERY_KEY = 'absence-types'
export const WARNINGS_TOLERANCE_URL = 'settings/absence-type'
export const WARNINGS_TOLERANCE_UPDATE_QUERY_KEY = 'absence-types-update'

// ROTA
export const ROTA_GENERATED_URL = 'rota/has-rota'
export const ROTA_GENERATED_QUERY_KEY = 'has-rota'
export const ROTA_REMOVE_URL = 'rota/remove-rota'
export const ROTA_REMOVE_QUERY_KEY = 'remove-rota'

// ABSENCES
export const ABSENCES_URL = 'absences'
export const ABSENCES_QUERY_KEY = 'absences'
export const ABSENCE_UPDATE_QUERY_KEY = 'update-absence'
export const ABSENCE_DELETE_QUERY_KEY = 'delete-absence'
export const ABSENCE_CREATE_QUERY_KEY = 'create-absence'
export const ABSENCES_PAST_QUERY_KEY = 'absences-past'
export const ABSENCES_UPCOMING_QUERY_KEY = 'absences-upcoming'
export const ABSENCES_TODAY_QUERY_KEY = 'absences-today'

// ABSENCES TYPES
export const ABSENCE_TYPES_QUERY_KEY = 'absence-types'
export const ABSENCE_TYPES_URL = 'settings/absence-type'
export const ABSENCE_TYPE_UPDATE_QUERY_KEY = 'absence-types-update'

// USERS
export const USERS_URL = 'users'
export const USERS_QUERY_KEY = 'users-rota'

// GENERATE
export const GENERATE_URL = 'rota/generate'
export const CHECK_ROTA_GENERATED_QUERY_KEY = 'checkRotaGenerated'

// RESIDENTS
export const RESIDENTS_URL = 'residents'
export const RESIDENT_DATA_KEY = 'resident'
export const RESIDENTS_QUERY_KEY = 'residents-rota'

// SKILLS
export const SKILLS_URL = 'skills'
export const SKILLS_QUERY_KEY = 'skills-rota'

// SHIFT TYPES
export const SHIFT_TYPES_URL = 'settings/shift-types'
export const SHIFT_TYPES_QUERY_KEY = 'shift-types'
export const SHIFT_TYPES_UPDATE_QUERY_KEY = 'shift-types-update'

// VISIT TYPES
export const VISIT_TYPES_URL = 'settings/visit-types'
export const VISIT_TYPES_QUERY_KEY = 'visit-types'
export const VISIT_TYPES_UPDATE_QUERY_KEY = 'visit-types-update'

// ROTA PATTERNS
export const ROTA_PATTERN_URL = 'rota-patterns'
export const ROTA_PATTERN_QUERY_KEY = 'rota-pattern'
export const ROTA_PATTERN_CREATE_QUERY_KEY = 'rota-pattern-create'
export const ROTA_PATTERN_UPDATE_QUERY_KEY = 'rota-pattern-update'
export const ROTA_PATTERN_DELETE_QUERY_KEY = 'rota-pattern-delete'

// ROTA PATTERN DESCRIPTION
export const ROTA_GENERATE_DESCRIPTION_URL =
  '/rota-schedule/generate-description'
export const ROTA_PATTERN_DESCRIPTION_QUERY_KEY = 'rota-pattern-description'

// MONITORING
export const TODAY_MONITORING_URL = 'rota-reporting/monitoring'
export const TODAY_MONITORING_QUERY_KEY = 'today-monitoring'

// CARE MANAGEMENT
export const CHECK_ADDRESS_URL = 'rota/check-address'
export const CHECK_ADDRESS_QUERY_KEY = 'check-address-rota'
export const CHECK_FUNDING_TYPE_URL = 'rota/check-funding'
export const CHECK_FUNDING_TYPE_QUERY_KEY = 'check-funding-rota'

// ALLOCATION TEMPLATE
export const ALLOCATION_TEMPLATE_LIST_URL = 'rota/list'
export const ALLOCATION_TEMPLATE_LIST_QUERY_KEY = 'allocation-template-list'
export const ALLOCATION_TEMPLATE_CREATE_URL = 'rota/save-template'
export const ALLOCATION_TEMPLATE_CREATE_QUERY_KEY = 'allocation-template-create'

export const TRAVEL_RATE_CARD_SETTINGS_URL = 'travel-rate-cards'
export const TRAVEL_RATE_CARD_SETTINGS_QUERY_KEY = 'travelRateCardSettings'
export const TRAVEL_RATE_CARD_SETTINGS_HOME_URL = 'travel-rate-cards/home'
export const TRAVEL_RATE_CARD_SETTINGS_HOME_QUERY_KEY =
  'travelRateCardSettingsHome'

// PAYMENT CARDS
export const PAY_RATE_CARDS_URL = 'pay-rate-cards'
export const PAY_RATE_CARDS_QUERY_KEY = 'pay-rate-cards'
export const PAY_RATE_CARDS_UPDATE_QUERY_KEY = 'pay-rate-cards-update'
export const PAY_RATE_CARD_HISTORY_QUERY_KEY = 'pay-rate-card-history'
export const PAY_RATES_SETTINGS_URL = 'home-settings/payrates'
export const PAY_RATES_SETTINGS_QUERY_KEY = 'pay-rates-settings'
export const PAY_RATES_SETTINGS_UPDATE_QUERY_KEY = 'pay-rates-settings-update'

// USER SETTINGS
export const USER_SETTINGS_URL = 'user-settings'
export const USER_SETTINGS_QUERY_KEY = 'user-settings'
export const USER_SETTINGS_PAYRATE_CREATE_QUERY_KEY =
  'user-settings-payrate-create'
export const USER_SETTINGS_PAYRATE_UPDATE_QUERY_KEY =
  'user-settings-payrate-update'
export const USER_SETTINGS_PAYRATE_DELETE_QUERY_KEY =
  'user-settings-payrate-delete'

// EMAIL
export const EMAIL_SEND_PUBLISHED_ROTA_URL = 'email/send-published-rota-email'
export const EMAIL_SEND_PUBLISHED_ROTA_QUERY_KEY = 'send-published-rota-email'

// INVOICING RATE CARDS
export const INVOICING_RATE_CARDS_URL = 'invoicing-rate-cards'
export const INVOICING_RATE_CARDS_QUERY_KEY = 'invoicing-rate-cards'
export const INVOICING_RATE_CARDS_UPDATE_QUERY_KEY =
  'invoicing-rate-cards-update'
export const INVOICING_RATE_HISTORY_QUERY_KEY = 'invoicing-rate-history'
export const INVOICING_SETTINGS_URL = 'home-settings/invoicing'
export const INVOICING_SETTINGS_QUERY_KEY = 'invoicing-settings'
export const INVOICING_SETTINGS_UPDATE_QUERY_KEY = 'invoicing-settings-update'

// FUNDERS
export const FUNDERS_URL = 'funders'
export const FUNDERS_QUERY_KEY = 'funders'
export const FUNDER_QUERY_KEY = 'funder'
export const FUNDERS_CREATE_QUERY_KEY = 'funders-create'
export const FUNDERS_UPDATE_QUERY_KEY = 'funders-update'
export const FUNDERS_DELETE_QUERY_KEY = 'funders-delete'

// RESIDENT FUNDING
export const RESIDENT_FUNDING_URL = 'resident-funding'
export const RESIDENT_FUNDING_QUERY_KEY = 'resident-funding'
export const RESIDENT_FUNDING_CREATE_QUERY_KEY = 'resident-funding-create'
export const RESIDENT_FUNDING_UPDATE_QUERY_KEY = 'resident-funding-update'
export const RESIDENT_FUNDING_DELETE_QUERY_KEY = 'resident-funding-delete'
export const FUNDERS_FROM_CONTACT_QUERY_KEY = 'funders-from-contact'
